
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahireinpune() {



    const cardData =
    {
        keyword: 'Urbania Hire in Pune  ',
        heading: 'Amruta Travels: Urbania Hire in Pune ',
        headingDescription: 'Amruta Travels offers Urbania Hire in Pune, providing a comfortable and reliable solution for group travel, whether it’s for corporate events, family outings, school trips, airport transfers, railway station pickups, or weekend getaways. Our luxurious Force Urbania vans, available in 13-seater and 17-seater options, feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania hire in Pune simple, safe, and stress-free, allowing you to travel together in comfort and style.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



 "services": [
  {
    "name": "Urbania hire Pune for outstation trip",
    "description": "Urbania hire in Pune for outstation trips offering a premium travel experience with spacious push-back seating, powerful air conditioning, smooth suspension, and ample luggage space. Ideal for family vacations, group tours, corporate offsite travel, pilgrimage journeys, and long-distance road trips. Vehicles are well-maintained and driven by experienced chauffeurs familiar with highways and tourist routes."
  },
  {
    "name": "Urbania hire Pune airport transfer",
    "description": "Urbania hire service in Pune for airport transfers providing timely pickup and drop, comfortable seating for groups, large luggage capacity, clean interiors, and professional drivers. Perfect for corporate teams, wedding guests, families, and international travelers needing reliable and stress-free airport transportation."
  },
  {
    "name": "Urbania hire Pune wedding transport",
    "description": "Urbania hire in Pune for wedding transport designed for smooth guest movement, family transfers, and event coordination. Offers luxury interiors, comfortable seating, air-conditioning, and reliable service for weddings, receptions, engagements, and destination wedding travel."
  },
  {
    "name": "Urbania van hire Pune local sightseeing",
    "description": "Urbania van hire in Pune for local sightseeing covering city attractions, temples, shopping areas, forts, museums, and tourist destinations. Ideal for families, tourists, and corporate guests looking for comfortable city travel with flexible itineraries and professional drivers."
  },
  {
    "name": "Urbania hire Pune picnic / group travel",
    "description": "Urbania hire in Pune for picnic and group travel suitable for school outings, office picnics, family gatherings, and friend groups. Provides safe, spacious, and comfortable transportation with enough room for passengers, bags, and picnic essentials."
  },
  {
    "name": "Urbania hire for Pune to Lonavala trip",
    "description": "Urbania hire from Pune to Lonavala offering smooth hill driving, excellent road grip, comfortable seating, and panoramic windows for scenic views. Ideal for weekend trips, family holidays, group outings, and corporate team getaways."
  },
  {
    "name": "Urbania hire Pune weekend travel",
    "description": "Urbania hire in Pune for weekend travel perfect for short holidays, nearby tourist destinations, hill stations, beaches, and religious places. Flexible rental options, clean vehicles, and experienced drivers ensure a relaxed and enjoyable journey."
  },
  {
    "name": "Urbania hire Pune corporate travel",
    "description": "Urbania hire service in Pune for corporate travel including employee transport, client visits, conferences, meetings, offsite programs, and business tours. Maintains professional standards with punctual service, uniformed drivers, and premium comfort."
  },
  {
    "name": "Cheap Urbania hire Pune",
    "description": "Affordable Urbania hire in Pune offering competitive pricing without compromising on vehicle quality, safety, comfort, or service. Ideal for budget-conscious travelers seeking premium group transportation at reasonable rates."
  },
  {
    "name": "Best Urbania hire services in Pune",
    "description": "Best Urbania hire services in Pune providing modern vehicles, experienced chauffeurs, transparent pricing, flexible booking options, and excellent customer support for local, airport, corporate, and outstation travel needs."
  },
  {
    "name": "Urbania hire in Hadapsar Pune",
    "description": "Urbania hire service available in Hadapsar Pune for residents, corporate offices, and travelers requiring comfortable group transportation for local travel, airport transfers, weddings, and outstation tours."
  },
  {
    "name": "Urbania hire in Kharadi Pune",
    "description": "Urbania hire in Kharadi Pune ideal for IT professionals, corporate parks, airport travel, business meetings, and weekend trips with reliable service and luxury comfort."
  },
  {
    "name": "Urbania hire in Baner Pune",
    "description": "Urbania hire service in Baner Pune suitable for executives, families, and group travelers looking for premium transportation for city travel, corporate movement, and outstation journeys."
  },
  {
    "name": "Urbania hire in Wagholi Pune",
    "description": "Urbania hire in Wagholi Pune providing smooth and comfortable travel for airport drops, family trips, local sightseeing, and long-distance tours with professional drivers."
  },
  {
    "name": "Urbania hire in Pimpri Chinchwad",
    "description": "Urbania hire service in Pimpri Chinchwad offering reliable and spacious group transport for industrial areas, corporate travel, family outings, and tour packages."
  },
  {
    "name": "Urbania hire near Swargate Pune",
    "description": "Urbania hire near Swargate Pune ideal for tour departures, pilgrimage travel, long-distance routes, and group journeys with easy access to major highways."
  },
  {
    "name": "Urbania hire in Kothrud Pune",
    "description": "Urbania hire service in Kothrud Pune for residential societies, families, and corporate groups planning comfortable local and outstation travel."
  },
  {
    "name": "Urbania hire in Wakad Pune",
    "description": "Urbania hire in Wakad Pune suitable for IT employees, corporate offices, airport transfers, weekend trips, and group outings with premium comfort."
  },
  {
    "name": "Urbania hire in Aundh Pune",
    "description": "Urbania hire service in Aundh Pune offering luxury group travel for executives, families, weddings, and business travel with punctual and reliable service."
  },
  {
    "name": "Urbania hire in Shivaji Nagar Pune",
    "description": "Urbania hire in Shivaji Nagar Pune ideal for central city travel, sightseeing tours, corporate movement, and comfortable outstation journeys."
  },
  {
    "name": "Urbania hire Pune booking online",
    "description": "Online booking available for Urbania hire in Pune with quick confirmation, transparent pricing, flexible scheduling, and customer support for hassle-free reservations."
  },
  {
    "name": "Pune to Grishneshwar Jyotirlinga Urbania on rent",
    "description": "Urbania on rent from Pune to Grishneshwar Jyotirlinga for devotional group travel offering comfort, long-distance support, experienced drivers, and well-planned pilgrimage journeys."
  },
  {
    "name": "Pune to Alibaug Urbania on rent",
    "description": "Urbania rental from Pune to Alibaug ideal for beach trips, weekend getaways, family holidays, and group tours with relaxed coastal travel experience."
  },
  {
    "name": "Pune to Ganpatipule Urbania on rent",
    "description": "Urbania on rent from Pune to Ganpatipule for Konkan coastal travel providing comfort, safety, and smooth long-distance road journeys."
  },
  {
    "name": "Pune to Ratnagiri Urbania on rent",
    "description": "Urbania rental service from Pune to Ratnagiri for family travel, Konkan darshan tours, temple visits, and group vacation plans."
  },
  {
    "name": "Pune to Imagica Urbania on rent",
    "description": "Urbania on rent from Pune to Imagica for school trips, corporate outings, family entertainment travel, and group fun trips with safe and comfortable transport."
  },
  {
    "name": "Pune to Khatu Shyam tour package",
    "description": "Khatu Shyam tour package from Pune with Urbania offering long-distance comfort, planned itineraries, and smooth spiritual travel for devotees and groups."
  },
  {
    "name": "Pune to Jaisalmer tour package",
    "description": "Jaisalmer tour package from Pune with Urbania for desert sightseeing, heritage exploration, group tours, and long-distance luxury road travel."
  },
  {
    "name": "12 Jyotirlinga tour package Urbania on rent",
    "description": "12 Jyotirlinga tour package with Urbania on rent providing a well-organized spiritual journey, comfortable seating, experienced drivers, and support for long multi-day travel."
  },
  {
    "name": "Pune to Ayodhya Urbania on rent",
    "description": "Urbania rental from Pune to Ayodhya suitable for spiritual tours, family pilgrimages, group travel, and comfortable long-distance journeys."
  }
],
"tableData": [
  ["Urbania hire Pune for outstation trip", "Urbania hire Pune airport transfer"],
  ["Urbania hire Pune wedding transport", "Urbania van hire Pune local sightseeing"],
  ["Urbania hire Pune picnic / group travel", "Urbania hire for Pune to Lonavala trip"],
  ["Urbania hire Pune weekend travel", "Urbania hire Pune corporate travel"],
  ["Cheap Urbania hire Pune", "Best Urbania hire services in Pune"],
  ["Urbania hire in Hadapsar Pune", "Urbania hire in Kharadi Pune"],
  ["Urbania hire in Baner Pune", "Urbania hire in Wagholi Pune"],
  ["Urbania hire in Pimpri Chinchwad", "Urbania hire near Swargate Pune"],
  ["Urbania hire in Kothrud Pune", "Urbania hire in Wakad Pune"],
  ["Urbania hire in Aundh Pune", "Urbania hire in Shivaji Nagar Pune"],
  ["Urbania hire Pune booking online", "Pune to Grishneshwar Jyotirlinga Urbania on rent"],
  ["Pune to Alibaug Urbania on rent", "Pune to Ganpatipule Urbania on rent"],
  ["Pune to Ratnagiri Urbania on rent", "Pune to Imagica Urbania on rent"],
  ["Pune to Khatu Shyam tour package", "Pune to Jaisalmer tour package"],
  ["12 Jyotirlinga tour package Urbania on rent", "Pune to Ayodhya Urbania on rent"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxurious Urbania for Comfortable Group Travel",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire in Pune, combining elegance, comfort, and practicality. Perfect for small to medium-sized groups, it delivers a premium travel experience on every trip."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Special Events",
    "WhyChoosedescription": "Whether it’s a corporate outing, family trip, wedding, or VIP transport, hiring an Urbania ensures your passengers travel in style and comfort throughout Pune and beyond."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "The Urbania features plush seating, generous legroom, air conditioning, large windows, and ample luggage space, making it perfect for day trips, long journeys, or city tours."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are experienced, courteous, and well-trained to handle the Urbania, ensuring a safe, smooth, and pleasant ride for every passenger."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Enjoy the luxury of an Urbania hire at competitive rates. Amruta Travels provides clear pricing with no hidden charges, offering excellent value for your travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Vehicles",
    "WhyChoosedescription": "All our Urbania vehicles are regularly serviced and sanitized, guaranteeing high standards of hygiene, safety, and comfort for every trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible scheduling, customizable routes, and convenient pickup/drop-off points tailored to your itinerary, whether local or outstation."
  },
  {
    "WhyChooseheading": "Effortless Booking with Dedicated Support",
    "WhyChoosedescription": "Booking Urbania Hire in Pune is quick and hassle-free. Our friendly customer support team will assist you from booking to planning your journey, ensuring a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I hire an Urbania in Pune with Amruta Travels?',
    answer: 'Hiring an Urbania in Pune is simple. You can book online, call our support team, or visit our office. We will help you select the perfect vehicle based on your group size and travel plans.'
  },
  {
    question: 'What are the features of the Urbania?',
    answer: 'The Urbania is equipped with luxurious interiors, comfortable seating, air conditioning, large windows for scenic views, ample luggage space, and modern amenities for a comfortable and stylish ride.'
  },
  {
    question: 'Is Urbania suitable for long-distance or outstation trips?',
    answer: 'Yes, the Urbania is ideal for both local and outstation trips. It ensures a comfortable, smooth, and safe journey even on long distances.'
  },
  {
    question: 'Does the Urbania hire include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and courteous driver who ensures a safe, timely, and comfortable journey.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All our Urbania vehicles are regularly serviced, cleaned, and maintained to ensure maximum comfort, hygiene, and safety for passengers.'
  },
  {
    question: 'What is the cost of hiring an Urbania in Pune?',
    answer: 'The cost depends on factors like duration, distance, and special requirements. Contact Amruta Travels for a customized quote tailored to your travel needs.'
  },
  {
    question: 'Can I customize pickup and drop-off locations?',
    answer: 'Yes, we offer flexible pickup and drop-off options and can customize routes to match your schedule, making your journey hassle-free.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire in Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated customer support, ensuring a premium travel experience for every group.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Patil',
    role: 'Corporate Team Lead, Pune',
    text: 'We hired an Urbania for a corporate day trip. The vehicle was comfortable, spacious, and clean. The driver was professional and courteous. Excellent service from Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Priya Joshi',
    role: 'Event Organizer, Pune',
    text: 'Booked an Urbania for transporting wedding guests. The bus was luxurious, roomy, and very comfortable. Everyone loved the smooth ride. Highly recommend Amruta Travels!',
    rating: 5
  }
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Urbania Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-hire-in-pune.jpg",
  "description":
    "Book Force Urbania hire in Pune with Amruta Travels for outstation trips, airport transfers, weddings, corporate travel, sightseeing, and group tours. Luxury 17-seater Urbania available across Pune and nearby destinations.",

  "provider": {
    "@type": "LocalBusiness",
    "name": "Amruta Travels",
    "telephone": "+91 7353109555",
    "url": "https://bushireinpune.com"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },

  "serviceType": "Urbania Van Rental / Luxury Mini Bus Hire",

  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "3120",
    "bestRating": "5",
    "worstRating": "1"
  },

  "offers": {
    "@type": "Offer",
    "url": "https://bushireinpune.com/urbania-hire-in-pune",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "priceSpecification": {
      "@type": "UnitPriceSpecification",
      "price": "6000",
      "unitText": "per day"
    }
  }
};


 




    return (
        <div>


   <Helmet>
      <title>
        Urbania Hire in Pune | Luxury 17 Seater Van Rental | Amruta Travels
      </title>

      <meta
        name="description"
        content="Book Urbania hire in Pune for airport transfers, weddings, corporate trips, sightseeing & outstation tours. Affordable 17-seater luxury van rental by Amruta Travels."
      />

      <meta
        name="keywords"
        content="Urbania hire Pune, Force Urbania rental Pune, 17 seater van Pune, luxury van hire Pune, Urbania booking Pune"
      />

      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:title" content="Urbania Hire in Pune | Amruta Travels" />
      <meta
        property="og:description"
        content="Luxury Urbania van hire in Pune for trips, weddings & corporate travel at best price."
      />
      <meta
        property="og:image"
        content="https://bushireinpune.com/assets/images/urbania-hire-in-pune.jpg"
      />
      <meta
        property="og:url"
        content="https://bushireinpune.com/urbania-hire-in-pune"
      />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Urbania Hire in Pune | Amruta Travels" />
      <meta
        name="twitter:description"
        content="Affordable and luxury Urbania van hire in Pune for group travel and tours."
      />
      <meta
        name="twitter:image"
        content="https://bushireinpune.com/assets/images/urbania-hire-in-pune.jpg"
      />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/97.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireinpune;